import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SCSS_LOADER_SPINNER_OVERLAY_COLOR } from '@upr-gds-web/components';
import { Subject } from 'rxjs';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';

const SPINNER_KEYS = {
    OVERRIDE: 'override',
    SUPPRESS: 'suppress',
    QUEUE: 'queue_start',
};

class SpinnerService {
    constructor() {
        this.spinner$ = new Subject();
        this.queueList = [];
    }
    show(waitFor) {
        if (waitFor && !this.waitFor) {
            this.waitFor = waitFor;
        }
        if (this.waitFor === SPINNER_KEYS.SUPPRESS) {
            return;
        }
        this.spinner$.next(true);
    }
    queue(key = SPINNER_KEYS.QUEUE, parent_key) {
        if (this.waitFor && this.queueList.length === 0)
            return;
        if (!this.waitFor && !parent_key) {
            this.waitFor = key;
        }
        const find = this.queueList.find((queue) => queue.key === key);
        if (find) {
            return;
        }
        const parent_item = this.queueList.find((queue) => queue.key === parent_key);
        if (!parent_item && parent_key) {
            this.queueList.push({ key: parent_key, parent_key: undefined });
        }
        this.queueList.push({ key, parent_key });
        this.spinner$.next(true);
    }
    hide(waitFor) {
        const queueLength = this.queueList.length;
        if (waitFor === SPINNER_KEYS.OVERRIDE ||
            (waitFor === this.waitFor && !queueLength) ||
            (!waitFor && !this.waitFor && !queueLength)) {
            this.clearValues();
            return;
        }
        if (queueLength && waitFor) {
            const list = this.getQueueList(waitFor);
            list.current = list.current.filter((queue) => queue.key !== waitFor);
            if (list.current.length <= 1 && list.left.length === 0) {
                this.clearValues();
                return;
            }
            else if (list.current.length <= 1 && list.left.length > 0) {
                this.queueList = list.left;
            }
            else {
                this.queueList = [...list.current, ...list.left];
            }
        }
    }
    getQueueList(key) {
        const current = [];
        const left = [];
        const find = this.queueList.find((queue) => queue.key === key);
        this.queueList.forEach((queue) => {
            if (queue.parent_key === find?.parent_key ||
                queue.key === key ||
                queue.key === find?.parent_key) {
                current.push(queue);
            }
            else {
                left.push(queue);
            }
        });
        return {
            current,
            left,
        };
    }
    clearValues() {
        this.waitFor = '';
        this.queueList = [];
        this.spinner$.next(false);
    }
}
SpinnerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SpinnerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SpinnerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SpinnerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SpinnerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class SpinnerComponent {
    constructor(spinner, changeDetection) {
        this.spinner = spinner;
        this.changeDetection = changeDetection;
        this.debug = false;
        this.backgroundColor = SCSS_LOADER_SPINNER_OVERLAY_COLOR;
        this.show = false;
    }
    ngOnInit() {
        this.spinnerSub = this.spinner.spinner$.subscribe((state) => {
            if (state !== this.show) {
                this.changeDetection.detach();
                this.show = state;
                this.changeDetection.detectChanges();
                this.changeDetection.reattach();
            }
        });
    }
    ngOnDestroy() {
        this.spinnerSub && this.spinnerSub.unsubscribe();
    }
}
SpinnerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SpinnerComponent, deps: [{ token: SpinnerService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
SpinnerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: SpinnerComponent, selector: "upr-spinner", inputs: { data: "data", isInline: "isInline", theme: "theme", debug: "debug" }, ngImport: i0, template: "<div\n\tclass=\"loading\"\n\trole=\"alert\"\n\taria-busy=\"true\"\n\tid=\"mySpin\"\n\t*ngIf=\"show || debug\"\n\t[ngStyle]=\"{ 'background-color': backgroundColor }\"\n>\n\t<gds-loading\n\t\tclass=\"loading-gds\"\n\t\t[data]=\"data\"\n\t\t[isInline]=\"isInline\"\n\t\t[theme]=\"theme\"\n\t></gds-loading>\n</div>\n", styles: [".hide-spin{display:block}.loading{display:flex;height:100%;width:100%;justify-content:center;align-items:center;position:fixed;top:0;left:0;z-index:999}.loading-gds{margin:auto}\n"], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'upr-spinner', template: "<div\n\tclass=\"loading\"\n\trole=\"alert\"\n\taria-busy=\"true\"\n\tid=\"mySpin\"\n\t*ngIf=\"show || debug\"\n\t[ngStyle]=\"{ 'background-color': backgroundColor }\"\n>\n\t<gds-loading\n\t\tclass=\"loading-gds\"\n\t\t[data]=\"data\"\n\t\t[isInline]=\"isInline\"\n\t\t[theme]=\"theme\"\n\t></gds-loading>\n</div>\n", styles: [".hide-spin{display:block}.loading{display:flex;height:100%;width:100%;justify-content:center;align-items:center;position:fixed;top:0;left:0;z-index:999}.loading-gds{margin:auto}\n"] }]
        }], ctorParameters: function () { return [{ type: SpinnerService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { data: [{
                type: Input
            }], isInline: [{
                type: Input
            }], theme: [{
                type: Input
            }], debug: [{
                type: Input
            }] } });

class SpinnerModule {
}
SpinnerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SpinnerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SpinnerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SpinnerModule, declarations: [SpinnerComponent], imports: [CommonModule], exports: [SpinnerComponent] });
SpinnerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SpinnerModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SpinnerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SpinnerComponent],
                    exports: [SpinnerComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

export { SPINNER_KEYS, SpinnerComponent, SpinnerModule, SpinnerService };
